import React, { useEffect } from 'react';

import ExportModalWithStoresAndPeriod from '@commons/ExportModalWithStoresAndPeriod';

import { usePeriodDatePickerState } from '@hooks/usePeriodDatePickerState';

import { ExportModalContainer } from '../../OrderAnalyticsStore/styledComponents';

/**
 * Export generic modal for food cost by store and by category
 *
 * @param {Object} props
 * @param {Array} props.exportGroups - List of groups to export
 * @param {Array} props.exportSelectedGroups - List of selected groups
 * @param {Function} props.setExportSelectedGroups - Function to set the selected groups
 * @param {Array} props.exportModalStores - List of stores to export
 * @param {Array} props.exportSelectedStores - List of selected stores
 * @param {Function} props.setExportSelectedStores - Function to set the selected stores
 * @param {Object} props.setExportPeriod - Function to set the export period
 */
export const AnalyticsFoodCostWithGroupsExportModal = (props) => {
  const {
    maxFutureDate,
    initialStartDate,
    initialEndDate,
    exportGroups,
    exportSelectedGroups,
    setExportSelectedGroups,
    exportModalStores,
    exportSelectedStores,
    setExportSelectedStores,
    setExportPeriod,
    clientStoreName,
    defaultTimezone,
  } = props;

  const periodPickerState = usePeriodDatePickerState(
    initialStartDate,
    initialEndDate,
    defaultTimezone,
  );

  useEffect(() => {
    if (!periodPickerState.startDate || !periodPickerState.endDate) {
      return;
    }

    setExportPeriod({ startDate: periodPickerState.startDate, endDate: periodPickerState.endDate });
  }, [periodPickerState.startDate, periodPickerState.endDate]);

  return (
    <ExportModalContainer>
      <ExportModalWithStoresAndPeriod
        clientStoreName={clientStoreName}
        defaultTimezone={defaultTimezone}
        filteredStores={exportModalStores}
        groups={exportGroups}
        maxFutureDate={maxFutureDate}
        periodPickerState={periodPickerState}
        selectedGroups={exportSelectedGroups}
        selectedStores={exportSelectedStores}
        setSelectedGroups={setExportSelectedGroups}
        setSelectedStores={setExportSelectedStores}
      />
    </ExportModalContainer>
  );
};

export default AnalyticsFoodCostWithGroupsExportModal;
